import { Card, CardActions, CardContent, Grid, Skeleton, Stack } from '@mui/material'

export default function AddressSkeleton() {
  return <Grid item xs={12} md={6} lg={4}>
    <Card elevation={0} sx={{
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#fff',
      '& .MuiSkeleton-root': {
        backgroundColor: '#dedede',
      },
    }}>
      <CardContent sx={{ flexGrow: 1 }}>
        <Stack spacing={1} alignItems="flex-start">
          <Skeleton variant="text" width="55%" height={21} />
          <Stack direction="row" spacing={1}>
            <Skeleton variant="rounded" width={118} height={23} />
            <Skeleton variant="rounded" width={108} height={23} />
          </Stack>
          <Stack spacing={0.25} sx={{ width: '100%' }}>
            <Skeleton variant="text" width="88%" height={17} />
            <Skeleton variant="text" width="72%" height={17} />
            <Skeleton variant="text" width="45%" height={17} />
          </Stack>
        </Stack>
      </CardContent>
      <CardActions sx={{ minHeight: 42, backgroundColor: 'rgba(0, 0, 0, 0.11)' }} />
    </Card>
  </Grid>
}
